import React from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-[70vh] bg-gray-50">
      <h1 className="text-9xl font-bold text-gray-500">
        <span className="text-main">4</span>0
        <span className="text-main">4</span>
      </h1>
      <div className="px-5 text-center">
        <p className="md:text-2xl text-xl font-semibold text-gray-800 mt-4">
          Sorry, we could not find this page.
        </p>
        <p className="text-gray-600 mt-2">
          But don’t worry, you can find plenty of other things on our homepage.
        </p>
      </div>
      <button
        onClick={() => navigate("/")}
        className="mt-6 px-6 py-3 bg-main1 text-white text-sm font-medium rounded transition"
      >
        Back to homepage
      </button>
    </div>
  );
};

export default NotFound;